// extracted by mini-css-extract-plugin
module.exports = {"innerPiecesTable":"pieces-table_innerPiecesTable__37msl","tableHead":"pieces-table_tableHead__1k3AW","tableBody":"pieces-table_tableBody__el0Qm"};